var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5V17.5H17.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33331 8.33334H6.66665C6.20641 8.33334 5.83331 8.70644 5.83331 9.16668V13.3333C5.83331 13.7936 6.20641 14.1667 6.66665 14.1667H8.33331C8.79355 14.1667 9.16665 13.7936 9.16665 13.3333V9.16668C9.16665 8.70644 8.79355 8.33334 8.33331 8.33334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.16666H13.3333C12.8731 4.16666 12.5 4.53975 12.5 4.99999V13.3333C12.5 13.7936 12.8731 14.1667 13.3333 14.1667H15C15.4602 14.1667 15.8333 13.7936 15.8333 13.3333V4.99999C15.8333 4.53975 15.4602 4.16666 15 4.16666Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.7f9af7513eec8b8d03c7a36686f6b0de.svg";
export { ForwardRef as ReactComponent };